<template lang="pug">
  header.app-header
    asset-pair
    .logo
      img(:src="imgSrc")
    user-button
</template>

<script>
  import AssetPair from './Header/AssetPair.vue'
  import Logo from '@/assets/logo.png'
  import UserButton from './Header/UserButton.vue'

  export default {
    components: {
      AssetPair,
      UserButton
    },
    data () {
      return {
        imgSrc: Logo
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/variables.sass"

  header
    position: fixed
    top: 0
    z-index: 10

    display: grid
    grid-template-columns: 1fr auto 1fr

    width: calc(100% - #{$asset-selector-width})
    height: $header-height

    margin-left: $asset-selector-width

    background-color: white
    border-bottom: $border

    .logo
      display: flex
      justify-content: center
      align-items: center

      height: 100%

      img
        height: 2rem
</style>
